import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Ab wann hat Tanja eine Verbesserung bemerkt?',
  answer: 'Bereits nach 7–10 Tagen zeigte Ben deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
}, {
  question: 'Ist das Topping auch für empfindliche Hunde geeignet?',
  answer: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
}, {
  question: 'Wie viel gibt man täglich?',
  answer: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Tanja hat mit der kleinsten Menge angefangen und langsam gesteigert.'
}, {
  question: 'Was wenn es bei meinem Hund nicht wirkt?',
  answer: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 py-16 max-w-3xl mx-auto" data-id="element-87">
      <h3 className="font-handwriting text-4xl text-forest font-bold text-center mb-10" data-id="element-88">
        Häufige Fragen
      </h3>

      <div className="space-y-4" data-id="element-89">
        {faqs.map((faq, index) => <div key={index} className="bg-white/60 border border-brown/10 rounded-xl overflow-hidden" data-id="element-90">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-91">
              <span className="font-serif font-bold text-forest text-lg pr-4" data-id="element-92">
                {faq.question}
              </span>
              <ChevronDown className={`text-brown/50 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-93" />
            </button>
            <AnimatePresence data-id="element-94">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-95">
                  <div className="px-6 pb-5 font-serif text-gray-700 leading-relaxed" data-id="element-96">
                    {'Bereits nach 7\u201310 Tagen zeigte Ben deutliche Verbesserungen. Bei manchen Hunden dauert es etwas l\xE4nger \u2014 bis zu 4 Wochen.'}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}